import React, { useEffect, useState, useCallback, useRef } from "react";
import { Button, Col, Row, Form, Table, Spinner } from "react-bootstrap";
import { ArrowBackIos } from "@material-ui/icons";
import {
  Module,
  ZOHO,
  CustomModule1_ApiName,
  CustomModule2_ApiName,
} from "../App";
import "../style/setting.css";

const Setting = ({ state }) => {
  var StreetFullApiName,
    StreetApiName,
    StreetNumberApiName,
    NeighborhoodApiName,
    ZIPCodeApiName,
    CityApiName,
    StateApiName,
    CountryApiName,
    LatitudeApiName,
    LongitudeApiName;
  var StreetFullFieldLabel,
    StreetFieldLabel,
    StreetNumberFieldLabel,
    NeighborhoodFieldLabel,
    ZIPCodeFieldLabel,
    CityFieldLabel,
    StateFieldLabel,
    CountryFieldLabel,
    LatitudeFieldLabel,
    LongitudeFieldLabel;

  //Modules all fields data
  const [FieldData, setFieldData] = useState();

  //Org all json data
  var OrgData = useRef({}); // create a ref to store OrgData

  //changes page: Back to AutoAddress
  const ChangePageHandler = () => {
    state("AutoAddress");
    // window.location.reload(true);
  };

  //refresh the component
  const [isloading, setIsloading] = useState(false);

  //Leads data mapping
  const [MappingData, setMappingData] = useState([
    { MapValue: "StreetFull", FieldLabel: "", ApiName: "" },
    { MapValue: "Street", FieldLabel: "", ApiName: "" },
    { MapValue: "StreetNumber", FieldLabel: "", ApiName: "" },
    { MapValue: "Neighborhood", FieldLabel: "", ApiName: "" },
    { MapValue: "ZIPCode", FieldLabel: "", ApiName: "" },
    { MapValue: "City", FieldLabel: "", ApiName: "" },
    { MapValue: "State", FieldLabel: "", ApiName: "" },
    { MapValue: "Country", FieldLabel: "", ApiName: "" },
    { MapValue: "Latitude", FieldLabel: "", ApiName: "" },
    { MapValue: "Longitude", FieldLabel: "", ApiName: "" },
  ]);

  //Get modules fields
  const getModuleFields = useCallback(() => {
    if (Module === "Leads") {
      ZOHO.CRM.META.getFields({
        Entity: Module,
      }).then(function (data) {
        //console.log(data);
        setFieldData(data.fields);
      });
    } else if (Module === "Contacts") {
      ZOHO.CRM.META.getFields({
        Entity: Module,
      }).then(function (data) {
        //console.log(data);
        setFieldData(data.fields);
      });
    } else if (Module === "Accounts") {
      ZOHO.CRM.META.getFields({
        Entity: Module,
      }).then(function (data) {
        //console.log(data);
        setFieldData(data.fields);
      });
    } else if (Module === CustomModule1_ApiName) {
      //console.log("custom module")
      ZOHO.CRM.META.getFields({
        Entity: CustomModule1_ApiName,
      }).then(function (data) {
        //console.log(data);
        setFieldData(data.fields);
      });
    } else if (Module === CustomModule2_ApiName) {
      ZOHO.CRM.META.getFields({
        Entity: CustomModule2_ApiName,
      }).then(function (data) {
        //console.log(data);
        setFieldData(data.fields);
      });
    }
  }, []); // add any dependencies inside the array

  //Get Org Variable Data
  const GetOrgVariable = useCallback(() => {
    if (Module === "Leads") {
      let apiList = {
        apiKeys: ["findaddressforzohocrmbygoogle__Leads_Module"],
      };

      ZOHO.CRM.API.getOrgVariable(apiList)
        .then(function (data) {
          //console.log(data);
          var LeadsOrgData = data.Success.Content;
          OrgData = JSON.parse(LeadsOrgData);
          //console.log(OrgData);
        })
        .finally(function (obj) {
          for (let i = 0; i < OrgData?.length; i++) {
            if (OrgData[i].ApiName !== "--none--") {
              const list = [...MappingData];
              list[i].FieldLabel = OrgData[i].FieldLabel;
              list[i].ApiName = OrgData[i].ApiName;
              setMappingData(list);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (Module === "Contacts") {
      let apiList = {
        apiKeys: ["findaddressforzohocrmbygoogle__Contacts_Module"],
      };

      ZOHO.CRM.API.getOrgVariable(apiList)
        .then(function (data) {
          //console.log(data);
          var LeadsOrgData = data.Success.Content;
          OrgData = JSON.parse(LeadsOrgData);
          //console.log(OrgData);
        })
        .finally(function (obj) {
          for (let i = 0; i < OrgData?.length; i++) {
            if (OrgData[i].ApiName !== "--none--") {
              const list = [...MappingData];
              list[i].FieldLabel = OrgData[i].FieldLabel;
              list[i].ApiName = OrgData[i].ApiName;
              setMappingData(list);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (Module === "Accounts") {
      let apiList = {
        apiKeys: ["findaddressforzohocrmbygoogle__Accounts_Module"],
      };

      ZOHO.CRM.API.getOrgVariable(apiList)
        .then(function (data) {
          //console.log(data);
          var LeadsOrgData = data.Success.Content;
          OrgData = JSON.parse(LeadsOrgData);
          //console.log(OrgData);
        })
        .finally(function (obj) {
          for (let i = 0; i < OrgData?.length; i++) {
            if (OrgData[i].ApiName !== "--none--") {
              const list = [...MappingData];
              list[i].FieldLabel = OrgData[i].FieldLabel;
              list[i].ApiName = OrgData[i].ApiName;
              setMappingData(list);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (Module === CustomModule1_ApiName) {
      let apiList = {
        apiKeys: ["findaddressforzohocrmbygoogle__Custom_Module_1_Value"],
      };

      ZOHO.CRM.API.getOrgVariable(apiList)
        .then(function (data) {
          //console.log(data);
          var LeadsOrgData = data.Success.Content;
          OrgData = JSON.parse(LeadsOrgData);
          //console.log(OrgData);
        })
        .finally(function (obj) {
          for (let i = 0; i < OrgData?.length; i++) {
            if (OrgData[i].ApiName !== "--none--") {
              const list = [...MappingData];
              list[i].FieldLabel = OrgData[i].FieldLabel;
              list[i].ApiName = OrgData[i].ApiName;
              setMappingData(list);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (Module === CustomModule2_ApiName) {
      let apiList = {
        apiKeys: ["findaddressforzohocrmbygoogle__Custom_Module_2_Value"],
      };

      ZOHO.CRM.API.getOrgVariable(apiList)
        .then(function (data) {
          //console.log(data);
          var LeadsOrgData = data.Success.Content;
          OrgData = JSON.parse(LeadsOrgData);
          console.log(OrgData);
        })
        .finally(function (obj) {
          for (let i = 0; i < OrgData?.length; i++) {
            if (OrgData[i].ApiName !== "--none--") {
              const list = [...MappingData];
              list[i].FieldLabel = OrgData[i].FieldLabel;
              list[i].ApiName = OrgData[i].ApiName;
              setMappingData(list);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []); // add any dependencies inside the array

  const valueData = [
    {
      MapValue: "StreetFull",
      FieldLabel: MappingData[0].FieldLabel,
      ApiName: MappingData[0].ApiName,
    },
    {
      MapValue: "Street",
      FieldLabel: MappingData[1].FieldLabel,
      ApiName: MappingData[1].ApiName,
    },
    {
      MapValue: "StreetNumber",
      FieldLabel: MappingData[2].FieldLabel,
      ApiName: MappingData[2].ApiName,
    },
    {
      MapValue: "Neighborhood",
      FieldLabel: MappingData[3].FieldLabel,
      ApiName: MappingData[3].ApiName,
    },

    {
      MapValue: "ZIPCode",
      FieldLabel: MappingData[4].FieldLabel,
      ApiName: MappingData[4].ApiName,
    },
    {
      MapValue: "City",
      FieldLabel: MappingData[5].FieldLabel,
      ApiName: MappingData[5].ApiName,
    },
    {
      MapValue: "State",
      FieldLabel: MappingData[6].FieldLabel,
      ApiName: MappingData[6].ApiName,
    },
    {
      MapValue: "Country",
      FieldLabel: MappingData[7].FieldLabel,
      ApiName: MappingData[7].ApiName,
    },
    {
      MapValue: "Latitude",
      FieldLabel: MappingData[8].FieldLabel,
      ApiName: MappingData[8].ApiName,
    },
    {
      MapValue: "Longitude",
      FieldLabel: MappingData[9].FieldLabel,
      ApiName: MappingData[9].ApiName,
    },
  ];

  const UpdateOrgVariable = () => {
    if (Module === "Leads") {
      setIsloading(true);
      let variableMap = {
        apiname: "findaddressforzohocrmbygoogle__Leads_Module",
        value: valueData,
      };
      ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", variableMap).then(function (
        data
      ) {
        //console.log("All selected data is saved to org variable. ");
        document.getElementById("orgupdate").innerHTML =
          "Leads Field Mapping updated successfully!";
        setIsloading(false);
      });
    } else if (Module === "Contacts") {
      setIsloading(true);
      let variableMap = {
        apiname: "findaddressforzohocrmbygoogle__Contacts_Module",
        value: valueData,
      };
      ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", variableMap).then(function (
        data
      ) {
        //console.log("All selected data is saved to org variable. ");
        document.getElementById("orgupdate").innerHTML =
          "Contacts Field Mapping updated successfully!";
        setIsloading(false);
      });
    } else if (Module === "Accounts") {
      setIsloading(true);
      let variableMap = {
        apiname: "findaddressforzohocrmbygoogle__Accounts_Module",
        value: valueData,
      };
      ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", variableMap).then(function (
        data
      ) {
        //console.log("All selected data is saved to org variable. ");
        document.getElementById("orgupdate").innerHTML =
          "Accounts Field Mapping updated successfully!";
        setIsloading(false);
      });
    } else if (Module === CustomModule1_ApiName) {
      setIsloading(true);
      let variableMap = {
        apiname: "findaddressforzohocrmbygoogle__Custom_Module_1_Value",
        value: valueData,
      };
      ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", variableMap).then(function (
        data
      ) {
        //console.log("All selected data is saved to org variable. ");
        document.getElementById("orgupdate").innerHTML =
          CustomModule1_ApiName + " Field Mapping updated successfully!";
        setIsloading(false);
      });
    } else if (Module === CustomModule2_ApiName) {
      setIsloading(true);
      let variableMap = {
        apiname: "findaddressforzohocrmbygoogle__Custom_Module_2_Value",
        value: valueData,
      };
      ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", variableMap).then(function (
        data
      ) {
        //console.log("All selected data is saved to org variable. ");
        document.getElementById("orgupdate").innerHTML =
          CustomModule2_ApiName + " Field Mapping updated successfully!";
        setIsloading(false);
      });
    }
  };

  useEffect(() => {
    ZOHO.CRM.UI.Resize({ height: "500", width: "800" });
    getModuleFields();
    GetOrgVariable();
  }, [getModuleFields, GetOrgVariable]);

  return (
    <>
      <div className="header">
        <Row>
          <Col sm={0.5}></Col>
          <Col sm={2}>
            <Button
              onClick={ChangePageHandler}
              className="back-btn"
              style={{ borderColor: "none", outline: "none" }}
            >
              <ArrowBackIos style={{ fontSize: "16px" }} />
              Back
            </Button>
          </Col>
          <Col sm={9.5}></Col>
        </Row>
      </div>
      {/* Body part */}
      <Row style={{ marginTop: "10px" }}>
        <Col sm={2}></Col>
        {/* map value */}
        <Col md={8} style={{ fontSize: "20px" }}>
          <div>
            <Table size="sm" striped bordered style={{ border: "0px" }}>
              <thead>
                <tr>
                  <th className="text-center text-uppercase">Map Value</th>
                  <th className="text-center text-uppercase">CRM Address Fields</th>
                </tr>
              </thead>
              <tbody>
                {/* Lead StreetFull */}
                <tr>
                  <td>Street Full</td>
                  <td>
                    <Form.Select
                      id="StreetFullLead"
                      onChange={(e) => {
                        StreetFullFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        StreetFullApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[0].FieldLabel = StreetFullFieldLabel;
                        list[0].ApiName = StreetFullApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[0].ApiName || "--none--"} // control with value
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        -None-
                      </option>
                      <option
                        hidden
                        value={MappingData[0].ApiName}
                        setdata={MappingData[0].FieldLabel}
                      >
                        {MappingData[0].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                {/* Lead Street */}
                <tr>
                  <td>Street</td>
                  <td>
                    <Form.Select
                      id="StreetLead"
                      onChange={(e) => {
                        StreetFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        StreetApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[1].FieldLabel = StreetFieldLabel;
                        list[1].ApiName = StreetApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[1]?.ApiName || "--none--"} // <-- controlled via value
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[1].ApiName}
                        setdata={MappingData[1].FieldLabel}
                      >
                        {MappingData[1].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                {/* Lead StreetNumber */}
                <tr>
                  <td>Street Number</td>
                  <td>
                    <Form.Select
                      id="StreetNumberLead"
                      onChange={(e) => {
                        StreetNumberFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        StreetNumberApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[2].FieldLabel = StreetNumberFieldLabel;
                        list[2].ApiName = StreetNumberApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[2]?.ApiName || "--none--"} // use value to control selection
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        -None-
                      </option>
                      <option
                        hidden
                        value={MappingData[2].ApiName}
                        setdata={MappingData[2].FieldLabel}
                      >
                        {MappingData[2].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>Neighborhood</td>
                  <td>
                    <Form.Select
                      id="NeighborhoodLead"
                      onChange={(e) => {
                        NeighborhoodFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        NeighborhoodApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[3].FieldLabel = NeighborhoodFieldLabel;
                        list[3].ApiName = NeighborhoodApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[3]?.ApiName || "--none--"} // controlled by value
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        -None-
                      </option>
                      <option
                        hidden
                        value={MappingData[3].ApiName}
                        setdata={MappingData[3].FieldLabel}
                      >
                        {MappingData[3].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>Zip Code</td>
                  <td>
                    <Form.Select
                      id="ZIPCodeLead"
                      onChange={(e) => {
                        ZIPCodeFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        ZIPCodeApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[4].FieldLabel = ZIPCodeFieldLabel;
                        list[4].ApiName = ZIPCodeApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[4]?.ApiName || "--none--"} // Corrected index & controlled select
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[4].ApiName}
                        setdata={MappingData[4].FieldLabel}
                      >
                        {MappingData[4].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>City</td>
                  <td>
                    <Form.Select
                      id="CityLead"
                      onChange={(e) => {
                        CityFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        CityApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[5].FieldLabel = CityFieldLabel;
                        list[5].ApiName = CityApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[5]?.ApiName || "--none--"} // Controlled dropdown
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[5].ApiName}
                        setdata={MappingData[5].FieldLabel}
                      >
                        {MappingData[5].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => {
                        return (
                          <option
                            key={index}
                            value={fields.api_name}
                            setdata={fields.field_label}
                          >
                            {fields.field_label}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>State</td>
                  <td>
                    <Form.Select
                      id="StateLead"
                      onChange={(e) => {
                        StateFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        StateApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[6].FieldLabel = StateFieldLabel;
                        list[6].ApiName = StateApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[6]?.ApiName || "--none--"} // Controlled select
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[6].ApiName}
                        setdata={MappingData[6].FieldLabel}
                      >
                        {MappingData[6].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => (
                        <option
                          key={index}
                          value={fields.api_name}
                          setdata={fields.field_label}
                        >
                          {fields.field_label}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>
                    <Form.Select
                      id="CountryLead"
                      onChange={(e) => {
                        CountryFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        CountryApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[7].FieldLabel = CountryFieldLabel;
                        list[7].ApiName = CountryApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[7]?.ApiName || "--none--"} // Controlled select
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[7].ApiName}
                        setdata={MappingData[7].FieldLabel}
                      >
                        {MappingData[7].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => (
                        <option
                          key={index}
                          value={fields.api_name}
                          setdata={fields.field_label}
                        >
                          {fields.field_label}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>Latitude</td>
                  <td>
                    <Form.Select
                      id="LatitudeLead"
                      onChange={(e) => {
                        LatitudeFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        LatitudeApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[8].FieldLabel = LatitudeFieldLabel;
                        list[8].ApiName = LatitudeApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[8]?.ApiName || "--none--"} // Controlled select
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[8].ApiName}
                        setdata={MappingData[8].FieldLabel}
                      >
                        {MappingData[8].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => (
                        <option
                          key={index}
                          value={fields.api_name}
                          setdata={fields.field_label}
                        >
                          {fields.field_label}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>

                <tr>
                  <td>Longitude</td>
                  <td>
                    <Form.Select
                      id="LongitudeLead"
                      onChange={(e) => {
                        LongitudeFieldLabel =
                          e.target.selectedOptions[0].getAttribute("setdata");
                        LongitudeApiName = e.target.selectedOptions[0].value;

                        const list = [...MappingData];
                        list[9].FieldLabel = LongitudeFieldLabel;
                        list[9].ApiName = LongitudeApiName;
                        setMappingData(list);
                      }}
                      value={MappingData[9]?.ApiName || "--none--"} // Controlled component
                      style={{
                        borderRadius: ".75rem",
                        fontSize: "18px",
                        opacity: "0px",
                        border: "0.2px solid #ECECEC",
                      }}
                    >
                      <option value="--none--" setdata="">
                        --none--
                      </option>
                      <option
                        hidden
                        value={MappingData[9].ApiName}
                        setdata={MappingData[9].FieldLabel}
                      >
                        {MappingData[9].FieldLabel}
                      </option>
                      {FieldData?.map((fields, index) => (
                        <option
                          key={index}
                          value={fields.api_name}
                          setdata={fields.field_label}
                        >
                          {fields.field_label}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                </tr>

              </tbody>

            </Table>
            <div>
              {isloading && <Spinner animation="grow" />}
              <p id="orgupdate" style={{ color: 'green' }}></p>
            </div>
            <Button
              className="save-btn w-25"
              style={{ float: "right" }}
              size="lg"
              onClick={() => UpdateOrgVariable()}
            >
              Save
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default Setting;
